import type { Assessment } from "../assessment-types";

export const TRAUMA_RESPONSES_ASSESSMENT: Assessment = {
  slug: "trauma-responses",
  emoji: "🌗",
  title: "Fight, Flight, Freeze & Fawn",
  tagline: "Which survival response feels most familiar?",
  intro:
    "This reflects on the different ways your body and mind may react when you feel under threat or overwhelmed. There are no right answers, just patterns worth noticing.",
  questions: [
    { id: "q1", text: "Do you find yourself getting irritable or snapping at people when you feel stressed?" },
    { id: "q2", text: "Do you notice an urge to leave, avoid or escape situations that feel tense?" },
    { id: "q3", text: "Do you find yourself going blank, numb or unable to think clearly under pressure?" },
    { id: "q4", text: "Do you find yourself agreeing or apologising just to keep the peace?" },
    { id: "q5", text: "Do you notice your body tensing up as if preparing to defend itself?" },
    { id: "q6", text: "Do you avoid conversations or people that might lead to conflict?" },
    { id: "q7", text: "Do you feel physically stuck or frozen when something upsetting happens?" },
    { id: "q8", text: "Do you focus on keeping others happy, even when it costs you?" },
    { id: "q9", text: "Do you notice yourself arguing or pushing back more than you'd like to?" },
    { id: "q10", text: "Do you distract yourself or busy yourself to avoid difficult feelings?" },
    { id: "q11", text: "Do you feel disconnected from your body or surroundings when stressed?" },
    { id: "q12", text: "Do you find it hard to say what you really think for fear of upsetting someone?" },
  ],
  bands: [
    {
      key: "low",
      minPercent: 0,
      headline: "Your answers suggest these survival responses show up rarely for you right now.",
      body:
        "That's a good sign of steadiness in how you meet stress. Everyone has these responses somewhere in their range, and it's still worth getting familiar with how yours work.",
    },
    {
      key: "some",
      minPercent: 30,
      headline: "You may recognise some patterns related to fight, flight, freeze or fawn responses.",
      body:
        "These responses are automatic and protective, not flaws. Noticing when they switch on is often the first step to feeling more choice in how you respond.",
    },
    {
      key: "often",
      minPercent: 55,
      headline: "Your answers suggest you may often notice one or more survival responses showing up.",
      body:
        "These reactions develop to keep you safe, often from a much earlier time in your life. Learning to recognise them as they happen can help them feel less overwhelming.",
    },
    {
      key: "high",
      minPercent: 78,
      headline: "Your answers suggest survival responses may be showing up strongly and often for you.",
      body:
        "This can be exhausting, but it makes sense as an adaptation to real or perceived threat over time. With practice, it's possible to build more calm and choice around these reactions.",
    },
  ],
  next: [
    { label: "Understand trauma responses", to: "/learn/trauma-responses" },
    { label: "Explore the window of tolerance", to: "/learn/window-of-tolerance" },
    { label: "Try a grounding exercise", to: "/grounding" },
    { label: "Try a breathing exercise", to: "/breathing" },
  ],
};
